import { hydrate, render, h } from "preact";
const AppPromise = import("./App");

const root = document.body;

AppPromise.then(({ default: App }) => {
  // Normal mode

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (document.visibilityState !== "prerender") {
    hydrate(h(App, null), root);

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/service-worker.js");
    }
  }

  // Prerender mode
  else {
    render(h(App, null), root);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.prerender();
  }
});
